import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

import { STRIPE_STATUS_QUERY_KEY } from "./useStripeStatus";

// Creates the Stripe Connect account for the tenant. Callers must handle the
// 409 "already exists" response themselves (see PaymentDetailsPage) — this
// hook does not swallow it, it just skips the global error toast so the page
// can decide whether that's actually an error or just a "refresh status" cue.
export const useCreateStripeAccount = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(`${tenantVal}/stripe/account`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [STRIPE_STATUS_QUERY_KEY, tenantVal],
      });
    },
  });
};
